import { useTranslation } from 'react-i18next';

import { Card, CardHeader } from '@/components/atoms/Card';
import type { LastMeasurement as LastMeasurementType } from '@/domain/bioscopes';
import { formatDateTimeWorded } from '@/utils/date';

interface LastMeasurementProps {
    lastMeasurement: LastMeasurementType;
}

function LastMeasurement({ lastMeasurement }: LastMeasurementProps) {
    const { t } = useTranslation();
    return (
        <Card
            as="section"
            padding="xl"
            header={<CardHeader title={t('common.labels.lastMeasurement')} level="h2" />}>
            {lastMeasurement
                ? formatDateTimeWorded(lastMeasurement.timestamp, 'minute')
                : t('common.labels.none')}
        </Card>
    );
}

export default LastMeasurement;
export { LastMeasurement };
